import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { useAuthStore } from '../store/authStore'
import { supabase } from '../lib/supabase'

export const useProfile = () => {
  const user = useAuthStore((s) => s.user)
  const qc   = useQueryClient()

  const query = useQuery({
    queryKey: ['profile', user?.id],
    enabled:  !!user?.id,
    queryFn:  async () => {
      const { data, error } = await supabase
        .from('profiles')
        .select('*')
        .eq('id', user.id)
        .single()
      if (error) throw error
      return data
    },
  })

  const update = useMutation({
    mutationFn: async (updates) => {
      const { error } = await supabase
        .from('profiles')
        .update(updates)
        .eq('id', user.id)
      if (error) throw error
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['profile', user?.id] }),
  })

  return { ...query, update }
}
